// StatementDetailStrip.jsx — the inline detail shown when a statement row is expanded.
// Reads only fields already in the list payload (no extra fetch). The full statement
// detail (PDF + reconciliation) remains available via the row menu's "View statement".
import React from "react";
import { format, parseISO } from "date-fns";

const LOCATION_TYPE_LABELS = { Consolidated: "Enterprise" };
const loc = (v) => LOCATION_TYPE_LABELS[v] ?? v ?? "—";

const fmtDate = (iso) => {
   if (!iso) return "—";
   try { const d = parseISO(iso); return isNaN(d) ? "—" : format(d, "MMM d, yyyy"); } catch { return "—"; }
};

const Field = ({ label, children }) => (
   <div style={{ minWidth: 130 }}>
      <div style={{ fontSize: 12, color: "#6c757d", marginBottom: 2 }}>{label}</div>
      <div style={{ fontSize: 14, color: "#212529" }}>{children}</div>
   </div>
);

export default function StatementDetailStrip({ row }) {
   const matched = Number(row?.invoice_state_match) || 0;
   const total = Number(row?.invoice_count) || 0;
   const partial = Number(row?.invoice_partial_count) || 0;
   const pct = row?.reconciliation_percent;

   return (
      <div
         style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "18px 32px",
            padding: "14px 18px",
            borderTop: "2px solid #e8eef5",
         }}
      >
         <Field label="Customer">{row?.cust_name || "—"}</Field>
         <Field label="Location">{loc(row?.sup_state_type)}</Field>
         <Field label="Statement date">{fmtDate(row?.sup_state_frmt_statement_date)}</Field>
         <Field label="Due date">{fmtDate(row?.terms_due_date)}</Field>
         <Field label="Terms">{row?.terms_label || "—"}</Field>
         <Field label="Reconciled">{total ? `${matched} / ${total}` : "—"}</Field>
         <Field label="Partial">{partial > 0 ? partial.toLocaleString() : "—"}</Field>
         <Field label="Progress">{pct == null || pct === "" ? "—" : `${Math.round(Number(pct) * 100)}%`}</Field>
         <Field label="Follow-ups">{row?.has_active_follow_ups ? "Pending" : "None"}</Field>
      </div>
   );
}
